/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Unlock_FailedInputs */

const cs_workflow_unlock_failed = /** @type {(inputs: Workflow_Unlock_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow se nepodařilo odemknout`)
};

const en_workflow_unlock_failed = /** @type {(inputs: Workflow_Unlock_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not unlock the workflow`)
};

/**
* | output |
* | --- |
* | "Could not unlock the workflow" |
*
* @param {Workflow_Unlock_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_unlock_failed = /** @type {((inputs?: Workflow_Unlock_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Unlock_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_unlock_failed(inputs)
	return cs_workflow_unlock_failed(inputs)
});